import { type ZodSchema, type ZodIssue } from 'zod'

/**
 * Custom zodResolver for React Hook Form compatibility with Zod v4
 * This resolver handles the new Zod v4 error structure that some form libraries
 * haven't updated to support yet.
 */
export const zodResolver =
  <T>(schema: ZodSchema<T>) =>
  (values: T) => {
    const result = schema.safeParse(values)
    if (result.success) {
      return {}
    }
    const errors: Record<string, string> = {}
    result.error.issues.forEach((error: ZodIssue) => {
      const path = error.path.join('.')
      errors[path] = error.message
    })
    return errors
  }

export const isValidUrl = (value: string): string | null => {
  if (!/^https:\/\/.*$/.exec(value)) {
    return 'URL must be a valid HTTPS URL'
  }
  return null
}
